import script from "./FamilySelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilySelector.vue?vue&type=script&lang=ts&setup=true"

import "./FamilySelector.vue?vue&type=style&index=0&id=eecdbb96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eecdbb96"]])

export default __exports__